<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM13.88 11.5402L9.63 15.7902C9.24 16.1802 8.61 16.1802 8.22 15.7902C7.83 15.4002 7.83 14.7702 8.22 14.3802L12.47 10.1302L11.2 8.86018C10.88 8.54018 11.11 8.00018 11.55 8.00018H15.49C15.77 8.00018 15.99 8.22018 15.99 8.50018V12.4402C15.99 12.8902 15.45 13.1102 15.14 12.7902L13.88 11.5402Z"
  />
</template>
